import { el, clear } from '../utils/dom.js';

export function openModal({ title, body, footer, size, onClose }) {
  const root = document.getElementById('modal-root');
  clear(root);

  const modal = el('div', { class: `modal ${size === 'lg' ? 'lg' : ''}` });
  const close = () => {
    clear(root);
    if (onClose) onClose();
  };

  modal.appendChild(el('div', { class: 'modal-head' },
    el('h3', { style: 'margin:0' }, title || ''),
    el('button', { class: 'btn ghost icon', onclick: close, html: '&times;' })
  ));
  const bodyEl = el('div', { class: 'modal-body' });
  if (typeof body === 'string') bodyEl.innerHTML = body;
  else if (body) bodyEl.appendChild(body);
  modal.appendChild(bodyEl);

  if (footer) {
    const f = el('div', { class: 'modal-foot' });
    if (Array.isArray(footer)) footer.forEach((b) => f.appendChild(b));
    else f.appendChild(footer);
    modal.appendChild(f);
  }

  const backdrop = el('div', { class: 'modal-backdrop', onclick: (e) => { if (e.target === backdrop) close(); } }, modal);
  root.appendChild(backdrop);

  document.addEventListener('keydown', function onEsc(e) {
    if (e.key === 'Escape') {
      close();
      document.removeEventListener('keydown', onEsc);
    }
  });

  return { close, body: bodyEl };
}

export function confirm({ title = 'Confirmar', message, confirmText = 'Aceptar', cancelText = 'Cancelar', danger = false } = {}) {
  return new Promise((resolve) => {
    let resolved = false;
    const cancelBtn  = el('button', { class: 'btn', onclick: () => { resolved = true; m.close(); resolve(false); } }, cancelText);
    const confirmBtn = el('button', { class: `btn ${danger ? 'danger' : 'primary'}`, onclick: () => { resolved = true; m.close(); resolve(true); } }, confirmText);
    const m = openModal({
      title,
      body: el('p', {}, message),
      footer: [cancelBtn, confirmBtn],
      onClose: () => { if (!resolved) resolve(false); },
    });
  });
}
